import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Download, ExternalLink } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const MIME = { docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', pdf: 'application/pdf' };

// Fidem Redacta: actions under a message where Fidem drafted a brief
export const FidemBriefActions = ({ brief, testid = 'fidem-brief' }) => {
  const { api } = useAuth();
  const download = async (fmt) => {
    try {
      const r = await api.get(`/crm/matters/${brief.matter_id}/brief/${fmt}`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([r.data], { type: MIME[fmt] }));
      const a = document.createElement('a');
      a.href = url; a.download = `${brief.kind}-${brief.matter_id.slice(0, 8)}.${fmt}`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error('No se pudo descargar'); }
  };
  return (
    <div data-testid={`${testid}-actions`} className="mt-3 flex flex-wrap gap-2">
      <button data-testid={`${testid}-docx`} onClick={() => download('docx')} className="flex items-center gap-1 rounded-full bg-blue-600 px-3 py-1 text-xs text-white"><Download className="h-3 w-3" />Word editable</button>
      <button data-testid={`${testid}-pdf`} onClick={() => download('pdf')} className="flex items-center gap-1 rounded-full bg-slate-700 px-3 py-1 text-xs text-white"><Download className="h-3 w-3" />PDF</button>
      <Link data-testid={`${testid}-open`} to={`/crm?caso=${brief.matter_id}`} className="flex items-center gap-1 rounded-full border border-amber-500/60 px-3 py-1 text-xs text-amber-200"><ExternalLink className="h-3 w-3" />Abrir en la causa</Link>
    </div>
  );
};
